function walkGameSecurity(conf,mapObj,resources){
    PIXI.Container.call(this);
    this.mapObj=mapObj;
    conf=$.extend(true,{
        "id":0,
        pos:[2,2],
        cell_size:10,
        speed:50,
    },conf);
    
    var map_size=this.mapObj.takeSize();
   
   conf.pos=[
       mt_rand(1,map_size[0]-2),
       mt_rand(1,map_size[1]-2)
   ];
    //security_max
    
    
//    var forceq={"0":[10,10],"1":[20,20]};
//    conf.pos=forceq[conf.id];
    
    this.conf=conf;
    
    
//    this.speed=0;
    
    this.pos=[conf.pos[0],conf.pos[1]];
    this.moveArr=[[1,-1],[-1,-1],[-1,1],[1,1]];
    
    
    
    
    this.mode="wait";//wait, block, move
    this.dir=[0,0];
    this.dir_id=-1;
    
    this.onPath=0;
    
    this.spineEl=new myPixiElement.spine({
        img:"security",
        spine_conf:{
            anim_loop:true,
            spineResource:resources
        }
    });
    
    
    this.addChild(this.spineEl);
    this.x=this.pos[0]*conf.cell_size;
    this.y=this.pos[1]*conf.cell_size;
    
    
    this.delta_sum=0;
    this.step_sum=0;
    this.sizeR=this.conf.cell_size*this.conf.cell_size/4;
    
    this.speedObj={step_max:0,step:0,speed_part:1};
}
walkGameSecurity.prototype = Object.create(PIXI.Container.prototype);
walkGameSecurity.prototype=$.extend(walkGameSecurity.prototype,{
    init:function(){
        this.updateSpeed();
    },
    isOnPath:function(){
        if(this.onPath){
            var onPath=this.onPath;
            this.onPath=0;
            return onPath;
        }
        return 0;
    },
    updateSpeed:function(){
        this.speed=this.conf.speed/1000*this.speedObj.speed_part;
    },
    myRemove:function(){
        this.destroy();
    },
    takeObj:function(){
      return {pos:copyArray(this.pos),id:this.conf.id};  
    },
    checkWithPath:function(pathArr){
        var i,pos;
        for(i in pathArr){
            pos=pathArr[i];
            if(lengthVectorPow(makeVector(pos,[this.x,this.y]))<=this.sizeR){
//                $.qLog(pos[0]+"_"+pos[1]+"()"+this.x+"_"+this.y+" ");
                this.onPath=2;
            }
        }
    },
    tryChangeDirection:function(){
        
        var id,dir,pos_test,avaArr=[],pos_type;
        for(id in this.moveArr){
            dir=this.moveArr[id];
            pos_test=[this.pos[0]+dir[0],this.pos[1]+dir[1]];
            pos_type=this.mapObj.takeField(pos_test);
            if(pos_type=="d" || pos_type=="w"){
                avaArr.push(intval(id));
            }
        }
        
        if(avaArr.length==0){
            this.mode="block";
            this.dir=[0,0];
            return false;
        }
        
        var setDir=-1;
        if(this.dir_id!=-1){
            //find direction -=90deg
            var next_dir=[];
            var dir_test=(this.dir_id+1)%4;
            if(in_array(dir_test,avaArr)){
                next_dir.push(dir_test);
            }
            dir_test=(this.dir_id+4-1)%4;
            if(in_array(dir_test,avaArr)){
                next_dir.push(dir_test);
            }
            if(next_dir.length>0){
                setDir=next_dir[mt_rand(0,next_dir.length-1)];
            }
        }
        if(setDir==-1){
            //find any direction
            setDir=avaArr[mt_rand(0,avaArr.length-1)];
        }
        
        this.mode="move";
        this.dir_id=setDir;
        this.dir=[this.moveArr[setDir][0],this.moveArr[setDir][1]];
        
        this.updateDirView();
        
        return true;
    },
    updateDirView:function(){
        var deg=angleClockFromVector(this.dir);
        
        this.rotation=deg/180*Math.PI;
    },
    manageSpeed:function(delta){
        if(this.speedObj.step_max==0){
            return false;
        }
        this.speedObj.step+=delta;
        if(this.speedObj.step>=this.speedObj.step_max){
            this.speedObj.step_max=0;
            this.speedObj.speed_part=1;
            this.updateSpeed();
        }
    },
    setSpeed:function(speed_part,howlong_mili){
        this.speedObj.step=0;
        this.speedObj.step_max=howlong_mili*60/1000;
        this.speedObj.speed_part=speed_part;
        this.updateSpeed();
    },
    myUpdate:function(delta){
        this.manageSpeed(delta);
        this.delta_sum+=delta;
        var step_sum_before=this.step_sum;
        this.step_sum+=delta*this.speed;
        
        if(this.mode=="block"){
            return false;
        }
        
        
//        var steps=this.delta_sum/this.speed;// jezeli step=1 to zrobionio pelny krok
        var steps_full=Math.floor(this.step_sum);
        
        
        var i,k;
        
        
        if(steps_full>0){
            for(i=0;i<steps_full;i++){
                //ile pelnych krokow
                var pos_type_prev=this.pos_type;
                
                this.pos=[this.pos[0]+this.dir[0],this.pos[1]+this.dir[1]];
                
                this.pos_type=this.mapObj.takeField(this.pos);
                if(this.pos_type=="s"){
                    //walker path was cleared, bodyguard was entering the cell
                    this.dir[0]=-this.dir[0];
                    this.dir[1]=-this.dir[1];
                    for(k in this.moveArr){
                        if(this.moveArr[k][0]==this.dir[0] && this.moveArr[k][1]==this.dir[1]){
                            this.dir_id=intval(k);
                        }
                    }
                    this.updateDirView();
                    this.step_sum+=(1-step_sum_before);
                    steps_full=Math.floor(this.step_sum);
                    
                }
                    
                
                
                var pos_next=[this.pos[0]+this.dir[0],this.pos[1]+this.dir[1]];
                var pos_type_next=this.mapObj.takeField(pos_next);
                
                
                if(this.pos_type=="w"){
                    this.mode="wait";
                    this.dir=[0,0];
                    this.onPath=3;
                }
                else{
                    if((pos_type_next!="d" && pos_type_next!="w") || this.mode=="wait"){
                        //change dir
                        if(!this.tryChangeDirection()){
                            i=steps_full-1;
                            this.step_sum=steps_full;
                        }
                    }
                }
                
               
            }
            
            
            this.step_sum-=steps_full;
            
        }
        
        
        
        this.x=(this.pos[0]+this.step_sum*this.dir[0])*this.conf.cell_size;
        this.y=(this.pos[1]+this.step_sum*this.dir[1])*this.conf.cell_size;
        
        
    } 
});